var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Status","items":_vm.statuses,"value":_vm.selectedStatus,"item-text":"1","item-value":"0","hide-details":"","outlined":"","clearable":""},on:{"input":_vm.emitChange}})}
var staticRenderFns = []

export { render, staticRenderFns }